export default __webpack_public_path__ + "static/media/seat-rounded-back.34df2e3f.webp";